import axios from "axios";
import {API_URL, base64ToBlob} from "../config";
import {
    GET_CAMPAIGN_NAME_LIST, GET_CONSULTATION_FOR_SIP,
    GET_MONITORING,
    GET_MONITORING_FOR_SIP,
    GET_MONITORING_DASHBOARD,
    SET_MONITORING_DASHBOARD_LOADING,
    GET_MONITORING_PAGINATION, GET_MONITORING_QUEUE,
    GET_MONITORINGS,
    GET_USER_SORT_FIELDS,
    SHOW_DETAIL_LOADING,
    SHOW_SIP_DETAILS_LOADING
} from "../types/typesMonitoringList";
import {AUDIO_LOADING, GET_NOTIFICATION_ERROR, UPLOAD_AUDIO_LOADING} from "../types/types";
import {
    getAudioUrlForPlayer,
    hideError,
    hideLoader, setAudioUnavailable, setQueueMonitorStats,
    showExportLoader,
    showLoader,
    showMonitorQueueLoader,
    updateSortFields
} from "../actions/actionsMonitoringList";
import {showAccessDeniedNotifications, showNotFoundNotifications} from "../actions/actionsNotifications";
import {setUserError} from "../actions/actionsUsersList";
import {hideErrorMessage} from "../actions/actions";
import {SET_CHECK_USER_FOR_BAN, SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {monitoringSortFieldsFetch, withBranchIdSortField} from "./sortFieldsFetchState";
import {keysFirstLetterToLowerCase} from "../../utils/callSessionUtils";

export function getMonitoringWithPaginationFilterAndSorting(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showLoader())
        dispatch(hideError())
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        return axios.post(`${API_URL}Monitoring/GetEventMonitorToUserGroup`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_MONITORINGS, payload: response.data.data.items})
                dispatch({type: GET_MONITORING_PAGINATION, payload: response.data.data})
                return response.data.data.items;
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    dispatch(setUserError(true))
                }
                return undefined;
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(hideLoader())
            })
    }
}

export function getMonitoringQueueList(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showMonitorQueueLoader(true));
        dispatch(hideError())
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        axios.get(`${API_URL}QueueMonitor/GetQueueMonitorList`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_MONITORING_QUEUE, payload: response.data.data?.queueCalls})
                dispatch(setQueueMonitorStats({
                    countActiveCalls: response.data.data?.callsCount,
                    withNotification: response.data.data?.withNotification
                }));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(showMonitorQueueLoader(false));
            })
    }
}

export function getUserSortFields(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        if (!jwtToken) {
            return;
        }
        if (monitoringSortFieldsFetch.requestInFlight) {
            return monitoringSortFieldsFetch.requestInFlight;
        }
        if (monitoringSortFieldsFetch.lastAttemptToken === jwtToken) {
            return;
        }

        monitoringSortFieldsFetch.lastAttemptToken = jwtToken;
        monitoringSortFieldsFetch.requestInFlight = axios.get(`${API_URL}Monitoring/GetUserSortFields`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const sortFieldsData = withBranchIdSortField(response.data.data);
                dispatch({type: GET_USER_SORT_FIELDS, payload: sortFieldsData});
                localStorage.setItem('callcenter:user_fields', JSON.stringify(sortFieldsData?.fields));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: 'Помилка завантаження даних'}})
                }
            })
            .finally(() => {
                monitoringSortFieldsFetch.requestInFlight = null;
                dispatch(showAccessDeniedNotifications(false));
            });

        return monitoringSortFieldsFetch.requestInFlight;
    }
}

export function getEventMonitorToUserDetail(id: number|any, jwtToken: any, isSip?: boolean, isConsultation?: boolean) {
    return (dispatch: (arg0: any) => void) => {
        if (isSip) {
            dispatch({type: SHOW_SIP_DETAILS_LOADING, payload: true})
        } else {
            dispatch({type: SHOW_DETAIL_LOADING, payload: true})
        }
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        dispatch(hideError());
        axios.get(`${API_URL}CallDetailInfo/GetCallDetail?callId=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const normalized = keysFirstLetterToLowerCase(response.data.data);
                if (isSip && !isConsultation) {
                    dispatch({type: GET_MONITORING_FOR_SIP, payload: normalized});
                } else if (isSip && isConsultation){
                    dispatch({type: GET_CONSULTATION_FOR_SIP, payload: normalized});
                } else {
                    dispatch({type: GET_MONITORING, payload: normalized});
                }
            })
            .catch(() => {
                dispatch({type: SHOW_DETAIL_LOADING, payload: false})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: SHOW_DETAIL_LOADING, payload: false})
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    if (e.data) {
                        dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: e.data.message}})
                    }
                    else {
                        dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: 'Щось пішло не так.'}})
                    }
                }
            })
            .finally(() => {
                    dispatch(showAccessDeniedNotifications(false));
                    if (isSip) {
                        dispatch({type: SHOW_SIP_DETAILS_LOADING, payload: false});
                    } else {
                        dispatch({type: SHOW_DETAIL_LOADING, payload: false});
                    }
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  false})
                }
            )
    }
}

export function getTempUrl(jwtToken: any, sessionId: any, callDetailId: number) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        dispatch(setAudioUnavailable(false));
        dispatch({type: AUDIO_LOADING, payload: true});
        axios.get(`${API_URL}Player/GetTempUrls?callDetailId=${callDetailId}&sessionId=${sessionId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getAudioUrlForPlayer(response.data.data));
                } else {
                    dispatch(showNotFoundNotifications(true));
                    dispatch(setAudioUnavailable(true));
                    dispatch(getAudioUrlForPlayer(null));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                }
                if (e?.response?.status === 404) {
                    dispatch(showNotFoundNotifications(true));
                    dispatch(setAudioUnavailable(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
                dispatch(getAudioUrlForPlayer(null));
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(showNotFoundNotifications(false));
                dispatch(hideLoader());
                dispatch({type: AUDIO_LOADING, payload: false});
            })
    }
}

export function uploadTempUrl(jwtToken: any, sessionId: any, callDetailId: number, isSpeakingAudio: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        dispatch({type: UPLOAD_AUDIO_LOADING, payload: true});
        axios.get(`${API_URL}Player/GetTempUrls?callDetailId=${callDetailId}&sessionId=${sessionId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then(async (response) => {
                if (response.data.statusCode === 200) {
                    // dispatch(getAudioUrlForPlayer(response.data.data));
                    let audioUrl = response.data.data;
                    const audioType1 = audioUrl?.filter((item: { audioType: number; }) => item?.audioType === 1);
                    const audioType2 = audioUrl?.filter((item: { audioType: number; }) => item?.audioType === 2);
                    const src = isSpeakingAudio?.code === 1
                        ? audioType1?.[0]?.tempUrl
                        : isSpeakingAudio?.code === 2
                            ? audioType2?.[0]?.tempUrl
                            : null;
                    const fileName = isSpeakingAudio?.code === 1
                        ? audioType1?.[0]?.fileName
                        : isSpeakingAudio?.code === 2
                            ? audioType2?.[0]?.fileName
                            : null;
                    try {
                        const responseUrl = await axios.get(`${src}`, {
                            responseType: 'blob',
                            headers: {
                                cache: 'no-store',
                                'Cache-Control': 'no-cache'
                            }
                        });

                        const blob = new Blob([responseUrl.data], { type: responseUrl.headers['content-type'] });

                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');

                        link.href = url;
                        link.setAttribute('download', `${fileName}`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    } catch (error: any) {
                        if (error?.response?.status === 403) {
                            dispatch(showNotFoundNotifications(true));
                        }
                    }
                } else {
                    dispatch(showNotFoundNotifications(true));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                }
                if (e?.response?.status === 404) {
                    dispatch(showNotFoundNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(showNotFoundNotifications(false));
                dispatch(hideLoader());
                dispatch({type: UPLOAD_AUDIO_LOADING, payload: false});
            })
    }
}

export function getMonitoringExcel(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError())
        dispatch(hideErrorMessage())
        dispatch(showExportLoader(true));
        axios.post(`${API_URL}Monitoring/GetMonitorExcelWithData`, dataSort,{
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            },
            responseType: 'json'
        })
            .then((response) => {
                const fileName = response.data.data.fileDownloadName;
                const fileContentsBase64 = response.data.data.fileContents;

                const blob = base64ToBlob(fileContentsBase64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                link.remove();
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showExportLoader(false));
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false))
            })
    }
}

export function getCampaignFilterList(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.get(`${API_URL}Monitoring/GetCampaignsAndQueues`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_CAMPAIGN_NAME_LIST, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: 'Помилка завантаження даних'}})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function updateUserFields(sortFields: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}Monitoring/UpdateUserSortFields`, sortFields, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const fields = withBranchIdSortField({fields: response.data.data?.fields}).fields;
                dispatch(updateSortFields(fields));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: 'Помилка оновлення Помилка оновлення стовпців'}})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function checkCallBanUsers(userName: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setUserError(false));
        axios.get(`${API_URL}CallBanUsersManager/CheckBanByNumber?number=${userName}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message + ` ${response.data?.data?.userName}`}})
                    dispatch({type: SET_CHECK_USER_FOR_BAN, payload: false});
                } else if (response.data.statusCode !== 500){
                    dispatch({type: SET_USER_STATUS_ERROR, payload:  {message: response.data.message}})
                    dispatch({type: SET_CHECK_USER_FOR_BAN, payload: false});
                } else {
                    dispatch({type: SET_CHECK_USER_FOR_BAN, payload: true});
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch({type: SET_CHECK_USER_FOR_BAN, payload: false});
            })
    }
}

const pickDashboardProp = (obj: any, camel: string) => {
    if (!obj) return undefined;
    const pascal = camel.charAt(0).toUpperCase() + camel.slice(1);
    return obj[camel] ?? obj[pascal];
};

const normalizeDashboardItem = (item: any) => ({
    callGroup: pickDashboardProp(item, 'callGroup') || '',
    total: pickDashboardProp(item, 'total') ?? 0,
    active: pickDashboardProp(item, 'active') ?? 0,
    success: pickDashboardProp(item, 'success') ?? 0,
    unsuccess: pickDashboardProp(item, 'unsuccess') ?? 0,
});

const normalizeDashboardList = (list: any) => {
    const items = Array.isArray(list) ? list : list && typeof list === 'object' ? Object.values(list) : [];
    return items.map(normalizeDashboardItem);
};

const normalizeMonitoringDashboard = (payload: any) => {
    if (!payload || typeof payload !== 'object') return null;
    const inner = (payload.campaigns || payload.Campaigns || payload.internalTotal || payload.InternalTotal
        || payload.externalTotal || payload.ExternalTotal || payload.campaignsTotal || payload.CampaignsTotal)
        ? payload
        : payload.data;
    if (!inner || typeof inner !== 'object') return null;
    return {
        campaigns: normalizeDashboardList(pickDashboardProp(inner, 'campaigns')),
        campaignsTotal: pickDashboardProp(inner, 'campaignsTotal')
            ? normalizeDashboardItem(pickDashboardProp(inner, 'campaignsTotal'))
            : null,
        internal: normalizeDashboardList(pickDashboardProp(inner, 'internal')),
        internalTotal: pickDashboardProp(inner, 'internalTotal')
            ? normalizeDashboardItem(pickDashboardProp(inner, 'internalTotal'))
            : null,
        external: normalizeDashboardList(pickDashboardProp(inner, 'external')),
        externalTotal: pickDashboardProp(inner, 'externalTotal')
            ? normalizeDashboardItem(pickDashboardProp(inner, 'externalTotal'))
            : null,
        total: pickDashboardProp(inner, 'total')
            ? normalizeDashboardItem(pickDashboardProp(inner, 'total'))
            : null,
    };
};

let monitoringDashboardRequestId = 0;

const readServerTimeMs = (response: any) => {
    const serverTime = Date.parse(response?.headers?.date || '');
    return Number.isNaN(serverTime) ? Date.now() : serverTime;
};

export function getMonitoringDashboard(payload: {filter?: {key: string; value: string}[]; userName?: string}, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        const requestId = ++monitoringDashboardRequestId;
        dispatch({type: SET_MONITORING_DASHBOARD_LOADING, payload: true});
        return axios.post(`${API_URL}Monitoring/GetMonitoringDashboard`, {
            filter: payload?.filter || [],
            userName: payload?.userName || ''
        }, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (requestId !== monitoringDashboardRequestId) return null;
                const raw = response?.data?.data ?? response?.data;
                const dashboard = normalizeMonitoringDashboard(raw);
                dispatch({type: GET_MONITORING_DASHBOARD, payload: dashboard});
                return {dashboard, snapshotTimeMs: readServerTimeMs(response)};
            })
            .catch((e) => {
                if (requestId !== monitoringDashboardRequestId) return null;
                dispatch({type: GET_MONITORING_DASHBOARD, payload: null});
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                }
                return null;
            })
            .finally(() => {
                if (requestId === monitoringDashboardRequestId) {
                    dispatch({type: SET_MONITORING_DASHBOARD_LOADING, payload: false});
                }
                dispatch(showAccessDeniedNotifications(false));
            });
    };
}

export function clearMonitoringDashboard() {
    return (dispatch: (arg0: any) => void) => {
        monitoringDashboardRequestId += 1;
        dispatch({type: GET_MONITORING_DASHBOARD, payload: null});
        dispatch({type: SET_MONITORING_DASHBOARD_LOADING, payload: false});
    };
}
